// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// import './icons'
// 移动端rem 适配
import 'amfe-flexible/index.js'
import '@/assets/css/index.css'
import '@/assets/css/reset.css'
import Vant from 'vant'
import 'vant/lib/index.css'

import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs

Vue.use(Vant)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js